export default __webpack_public_path__ + "static/media/Picture3.9940ef06.png";